import React, {useContext} from 'react';
import {AppContext} from '../../contexts/AppContext';

const convertToCsv = (data) => {
    const header = Object.keys(data[0]).join(';');
    const rows = data.map(row => Object.values(row).join(';'));
    return [header, ...rows].join("\n");
};

const downloadCsv = (data, filename = 'export.csv') => {
    const csv = convertToCsv(data);
    const BOM = "\uFEFF"; // UTF-8 BOM
    const blob = new Blob([BOM + csv], {type: 'text/csv;charset=utf-8;'});
    const url = URL.createObjectURL(blob);

    const dummyLink = document.createElement('a');
    dummyLink.href = url;
    dummyLink.setAttribute('download', filename);
    document.body.appendChild(dummyLink);
    dummyLink.click();
    document.body.removeChild(dummyLink);
};

const CsvExport = () => {

    const {filteredResults} = useContext(AppContext);

    const handleDownload = () => {
        const data = filteredResults.map(item => {
            return {
                kognitivId: item.kognitivId,
                name: item.title,
                netPrice: item.netPrice,
                price: item.price
            };
        });
        downloadCsv(data);
    };

    return <button className="btn btn-text btn-sm" onClick={handleDownload}>
        <span>CSV</span>
        <i className="icon icon--diverses-download">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path fill="#000" fillRule="nonzero" d="M16.313 6.688c.897 0 1.625-.728 1.625-1.625V1.688c0-.898-.728-1.625-1.625-1.625H1.688C.79.063.063.79.063 1.688v3.375c0 .897.727 1.625 1.625 1.625Zm0-1H1.688a.625.625 0 0 1-.625-.625V1.688c0-.345.28-.625.625-.625h14.625c.344 0 .625.28.625.625v3.375c0 .344-.28.625-.625.625M9 17.938h.011l.063-.006za.5.5 0 0 0 .284-.09l.02-.014.034-.028.016-.015 2.812-2.812a.5.5 0 0 0-.638-.765l-.069.057-1.96 1.96.001-6.669a.5.5 0 0 0-.992-.09l-.008.09v6.67l-1.959-1.96a.5.5 0 0 0-.638-.058l-.069.057a.5.5 0 0 0-.058.638l.058.07 2.813 2.812.015.015q.016.016.034.028l-.05-.043a.5.5 0 0 0 .354.146"/></svg>
        </i>
    </button>;
};

export default CsvExport;